export class QuickSearchResults {
  public constructor(init?: Partial<QuickSearchResults>) {
    Object.assign(this, init);
  }
  rowId: number;
  rowNumber: number;
  customerType: string;
  entityId: string;
  lotNumber: string;
  invoiceDate: Date;
  invoiceType: string;
  invoiceNumber: string;
  rate: number;
  cardNo: string;
  cardNumber: string;
  customerName: string;
  companyName: string;
  created: Date;
  dueDate: Date;
  delivery: string;
  dateSent: string;
  paymentType: string;
  referenceNumber: string;
  paymentAmount: number;
  currentBalance: number;
  adjustmentAmount: number;
  isFinalized: boolean;
  transactionDate: Date;
  isFrozen: boolean;
  oneTime: boolean;
  isSpecialInvoice: boolean;
  isFound: boolean;
  markedForPayment: boolean = false;
  paymentQueued: boolean = false;
  markedForDeletion: boolean = false;
  originalBalance: number;
  paymentApplied: boolean = false;
  invalidPayment: boolean = false;
  invalidReferenceNumber: boolean = false;
  datePaid: Date;
  queueType: number = 0;
  comments: string = ''; // 20241030 :: Ken Moss - added to accomodate aging comments from g_searchresults table
  commentDate: Date; //20241031 :: Ken Moss - added the date the comments were last updated - could be NULL.  DateTimeOffset in database
  commentUserName: string; //20241031 :: Ken Moss - added the user name that added/updating the aging comments - could be NULL.
  IsPortal: boolean = false; //20260509 :: Ken Moss - added to identify if the parker/customer is registered for the spACE-Portal
}
